import MainBody from "./MainBody";

export default MainBody;